import { useState } from 'react';
import { useAppStore } from '@/store/AppStore';
import Badge from '@/components/base/Badge';
import TeamDetail from './components/TeamDetail';
import type { Team } from '@/types';

export default function Ekipler() {
  const { teams, jobs } = useAppStore();
  const [selected, setSelected] = useState<Team | null>(null);

  function teamJobCount(teamName: string): number {
    return jobs.filter((j) => j.team === teamName).length;
  }

  return (
    <div className="mx-auto max-w-[1400px] space-y-6">
      <div>
        <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-accent-600">
          <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
          Yönetim
        </div>
        <h1 className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">Ekipler</h1>
        <p className="mt-1 text-sm text-foreground-500">Hangi ekip nerede, ne durumda?</p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {teams.map((team) => {
          const available = team.status === 'Müsait';
          return (
            <button
              key={team.id}
              type="button"
              onClick={() => setSelected(team)}
              className="rounded-lg border border-background-200 bg-white p-5 text-left transition-colors hover:border-primary-200 hover:bg-background-50"
            >
              <div className="flex items-start justify-between">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-50 text-primary-600">
                  <i className="ri-group-fill text-xl" />
                </div>
                <Badge tone={available ? 'green' : 'gold'}>{team.status}</Badge>
              </div>
              <h2 className="mt-4 font-heading text-lg font-bold text-foreground-950">{team.name}</h2>
              <div className="mt-1 text-sm text-foreground-500">
                {team.members.length} personel · {teamJobCount(team.name)} iş
              </div>
              <div className="mt-3 space-y-1 text-sm">
                {team.currentJob && (
                  <div className="flex items-center gap-2 text-foreground-700">
                    <i className="ri-map-pin-line text-foreground-400" />
                    <span className="truncate">{team.currentJob}</span>
                  </div>
                )}
                {team.location && (
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <i className="ri-building-line text-foreground-400" />
                    <span className="truncate">{team.location}</span>
                  </div>
                )}
              </div>
              <div className="mt-4 flex items-center gap-1 text-xs font-semibold text-primary-600">
                Detayları Gör
                <i className="ri-arrow-right-s-line" />
              </div>
            </button>
          );
        })}
      </div>

      {selected && <TeamDetail team={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}